/*
    author:june
    删除value为空的属性
*/
const getRemoveNullObject = (obj) => {
    let o = JSON.parse(JSON.stringify(obj))
    for(var key in o) {
        if (!o[key]) {
            delete o[key];    
        }
    }
    return o;
}
/*
    author:june
    jsonparse报错，返回空对象
*/
const getJsonParse = (val) => {
    try{
        return JSON.parse(val);
    } catch(error) {
        if (/eruda=true/.test(location.href)) {
            console.log('[JSON.parse:Error]',val);    
        }
        return {};
    }
}

function getDeepValue (res,key) {
    res = res || {};
    key = key || '';
    var v = JSON.parse(JSON.stringify(res));
    var flag = true;
    var arr = key.split('.') || [];
    arr.map(function(item,index){
        if (v[item]) {
           v = v[item]
        } else {
           flag = false;
        }
    })
    return {
        flag : flag,
        v : v,
    };
}
/*
    author:june
    getDeepVal(res,'data.coupon.item.name','string')
*/
const getDeepVal = (res,key,defval) => {
    let {flag=false, v=''} = getDeepValue(res,key);
    return flag ? v : defval;
}

export {
    getRemoveNullObject,
    getJsonParse,
    getDeepVal,
}



// WEBPACK FOOTER //
// ./node_modules/@kkmh/utils/src/object.js